export default __webpack_public_path__ + "static/media/drop-off-pin-orange.7a4259c4.svg";